import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UISection from 'UIComponents/section/UISection';
import { jsx as _jsx } from "react/jsx-runtime";
const MultipleEmailInputErrorBanner = ({
  onClose
}) => /*#__PURE__*/_jsx(UISection, {
  children: /*#__PURE__*/_jsx(UIAlert, {
    closeable: true,
    onClose: onClose,
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputMultipleEmailV2.asyncErrorMessage"
    })
  })
});
export default MultipleEmailInputErrorBanner;